import { flow, types } from 'mobx-state-tree'
import { fetchPosApprovals } from '../../network/fetchPos'
import { posApproveOrDecline } from '../../network/posApproveOrDeceline'
import { getErrorMessage, MessageTypes } from '../../utils'
import { RootStore } from '../store'

const Pos = types.model('Pos', {
  check: types.optional(types.string, ''),
  id: types.optional(types.number, 0),
  processingEntity: types.optional(types.string, ''),
  bankName: types.optional(types.string, ''),
  mid: types.optional(types.string, ''),
  tid: types.optional(types.string, ''),
  emsBusinessCategory: types.optional(types.string, ''),
  emsBusinessName: types.optional(types.string, ''),
  emsBankEntityId: types.optional(types.string, ''),
  emsBankTerminalId: types.optional(types.string, ''),
  createdAt: types.optional(types.string, ''),
  eecCreatedAt: types.optional(types.string, ''),
})

const Pagination = types.model('Pagination', {
  size: types.optional(types.number, 0),
  totalElements: types.optional(types.number, 0),
  totalPages: types.optional(types.number, 0),
  number: types.optional(types.number, 1),
})

const PosApprovals = types
  .model('PosApprovals', {
    pos: types.optional(types.array(Pos), []),
    pagination: types.optional(Pagination, {}),
  })
  .actions((self) => ({
    fetchPendingApprovals: flow(function* fetchPendingApprovals(status: string, sortOrder?: any) {
      try {
        const paginationData = self?.pagination
        const req = {
          status: status,
          pageNumber: paginationData?.number,
          pageSize: paginationData?.size,
          sortBy: sortOrder?.length > 0 ? sortOrder : undefined,
        }

        const response = yield fetchPosApprovals(req, RootStore.session.getTokens)
        self.pos = JSON.parse(JSON.stringify(response?.content))
        self.pagination = {
          ...self.pagination,
          ...response?.page,
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    approveOrDecline: flow(function* approveOrDecline(type: string) {
      try {
        const checkdItems = self?.pos?.filter((item) => item?.check?.toString() === 'true') ?? []
        const checkedIds = checkdItems?.map((item) => item.id) ?? []
        if (checkedIds?.length === 0) {
          throw 'error'
        }
        const req = {
          action: type,
          listOfMappingIds: checkedIds,
        }

        const response = yield posApproveOrDecline(req, RootStore.session.getTokens)
        RootStore.message.setMessage('Success', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    updateApprovalsOnCheck(id: number, isChecked: any) {
      const retData = self.pos.map((item) => {
        if (item?.id === id) {
          item.check = `${isChecked}`
          return item
        } else {
          return item
        }
      })
      self.pos = JSON.parse(JSON.stringify(retData))
    },
    updateApprovalsAllCheck(val: boolean) {
      const data = self.pos
      const retData = data?.map((item: any) => {
        return {
          ...item,
          check: `${val}`,
        }
      })
      self.pos = JSON.parse(JSON.stringify(retData))
    },
    updatePagination(selectedPage: number): void {
      self.pagination.number = selectedPage
    },
    updatePageSize(size: string): void {
      self.pagination.size = Number(size)
    },
  }))
  .views((self) => ({
    getApprovals() {
      return self.pos
    },
    getIsAllChecked() {
      const data = self?.pos
      return data?.filter((item) => item?.check === 'false')?.length === 0
    },
    getCheckedIds() {
      const checkdItems = self?.pos?.filter((item) => item?.check?.toString() === 'true') ?? []
      return checkdItems?.map((item) => item.id) ?? []
    },
  }))

const posApprovalData = PosApprovals.create({
  pos: [],
  pagination: {
    size: 10,
    totalElements: 0,
    totalPages: 0,
    number: 0,
  },
})

export { PosApprovals, posApprovalData }
